import {
  type AiModelEnum,
  getSampleVariantFromMaterial,
  PaginatedEvidenceList,
  SampleType,
  useApiSamplesV1SamplesRetrieveSuspense,
} from 'api';
import { SampleBreakdown, useSiteMaterial } from 'features';
import { useBreakpoint } from 'ui';

export const SampleDetail = ({
  sampleId,
  evidence,
  isOnline,
  onSuccessfulEvidenceSync,
}: {
  sampleId: number;
  evidence: PaginatedEvidenceList;
  isOnline: boolean;
  onSuccessfulEvidenceSync?: () => void;
}) => {
  const { isMobile } = useBreakpoint();
  const { data: siteMaterial } = useSiteMaterial();
  const { data: sample } = useApiSamplesV1SamplesRetrieveSuspense(sampleId);
  const aiModel = siteMaterial.material_spec.ai_model;

  return (
    <SampleBreakdown
      isMobile={isMobile}
      displayManualBreakdown={sample.type !== SampleType.AG}
      sample={sample}
      model={aiModel as AiModelEnum}
      evidence={evidence}
      variant={getSampleVariantFromMaterial(siteMaterial.material_spec.title) || 'alu'}
      isOnline={isOnline}
      mode="sample"
      onSuccessfulEvidenceSync={onSuccessfulEvidenceSync}
    />
  );
};
